import Backbone from 'backbone';

import ParseService from '~/services/parseService';
import Model from '~/models/parseModel';
import Collection from '~/collections/parseCollection';
import getReportPlusOnesService from '~/services/reportPlusOnesService';

/**
 * @member [reportService] reportService
 */
var reportService;
/**
 * Object report service, manages reportServices
 * @module services/reportServices
 * @returns {reportService[]}
 */
export default function() { // lazy initialization. we export function which returns servies. this way service will be created only when it will be really necessary

  var ReportModel = Model.extend({
    className: "Report",
    defaults: {
      'manualTitle': false,
    },

    /**
     * this function calculates the ranking for this report.
     * @function doRanking
     * @returns {Promise.<getPlusOnes>}
     * @memberOf ReportModel
     */
    doRanking: function() {
      return getReportPlusOnesService().fetch({
        all: true,
        cache: false,
        rules: {
          equals: [{
            key: 'report',
            val: {
              __type: "Pointer",
              className: "Report",
              objectId: this.attributes.id
            }
          }]
        }
      });
    },

  });

  /**
   * Represents a collection of Reports with classes as properties
   */

  var ReportsCollection = Collection.extend({
    model: ReportModel,
    /**
     * Gets an Object list by categories then count it,
     * displays by categories
     * @function doCountByCategory
     * @param categoriesCollection
     */

    doCountByCategory: function(categoriesCollection) {
      /**
       * @member [class] countedByCategory
       */
      var countedByCategory = {};
      /**
       * @member[class] countedByCategory.raw
       */
      countedByCategory.raw = {};
      /**
       * @member [ReportsCollection] that
       */
      var that = this;
      //
      _.each(this.models,
        /**
         * resolves if this object collection has some attributes
         * @function
         * @param thisModel
         */
        function(thisModel) {
          if (thisModel) {
            if (thisModel.attributes) {
              if (thisModel.attributes.category) {
                var thisCategoryID = thisModel.attributes.category.id;
              }
            }
          }
          if (_.has(countedByCategory.raw, thisCategoryID)) {
            // enters here if this date/day was already registered.
            countedByCategory.raw[thisCategoryID].count += 1;
          } else {
            //this date was not registered yet
            var newObject = {
              count: 1
            };
            countedByCategory.raw[thisCategoryID] = newObject;
          }


        });
      //countedByCategory.prep = {};
      /**
       * @member {class} countedByCategory.plotData
       */
      countedByCategory.plotData = {};
      /**
       * @member {array} countedByCategory.plotData.X
       */
      countedByCategory.plotData.X = [];
      /**
       * @member {array} countedByCategory.plotData.Y
       */
      countedByCategory.plotData.Y = [];
      /**
       * @member {array} countedByCategory.plotData.ID
       */
      countedByCategory.plotData.ID = [];
      /**
       * @member {array} countedByCategory.plotData.color
       */
      countedByCategory.plotData.color = [];

      //this part it's mapping data
      _.each(categoriesCollection.models,
        /**
         * @function
         * @param thisCategoryModel
         */
        function(thisCategoryModel) {
          if (countedByCategory.raw[thisCategoryModel.id]) {
            countedByCategory.plotData.Y.push(countedByCategory.raw[
              thisCategoryModel.id].count);
            countedByCategory.plotData.X.push(thisCategoryModel.id);
            countedByCategory.plotData.ID.push(thisCategoryModel.id);
            countedByCategory.plotData.color.push(thisCategoryModel.attributes
              .color);
          }
        });
      /**
       * @member [array] countedByCategory
       */
      this.countedByCategory = countedByCategory;
    }
  });

  /**
   * it's Report service, object type service of the collection
   * @member [Report Service] ReportService
   */
  var ReportService = ParseService.extend({
    sortBy: 'createdAt',
    order: 'dsc',
     // load by N items, this overrides the 1k limit 'parseService.js'
    model: ReportModel,
    collection: ReportsCollection,
    /**
     * gets report by user
     * @function changeAssignee
     * @param reportID
     * @param userID
     * @memberOf reportService
     */
    changeAssignee: function(reportID, userID, reason, coassignees) {
      /**
       *
       */
      return Parse.Cloud.run('assignUserToReport', {
        userID: userID,
        reportID: reportID,
        reason: reason,
        coassignees: coassignees
      });
    },
    /**
     * gets reports status in the collection
     * @function setReportStatus
     * @param reportID
     * @param statusID
     * @memberOf reportService
     */
    setReportStatus: function(reportID, statusID) {
      // service (extends ParseService)
      var ReportService = ParseService.extend({
        sortBy: 'createdAt',
        order: 'dsc',
        itemsOnPage: 100, // load by N items, this overrides the 1k limit 'parseService.js'
        model: ReportModel,
        collection: ReportsCollection,
        changeAssignee: function(reportID, userID) {
          Parse.Cloud.run('assignUserToReport', {
            userID: userID,
            reportID: reportID
          }).then(function() {
            // success
          },
		  function(error){
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
        },

      });
    }
  });
  return reportService || (reportService = new ReportService());
};
// only created once for application
